import { Box, Grid, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { InsightCard } from 'modules/project_management/components/InsightCard'

interface ProjectStatusSectionProps {
  completedTasks: number
  imputedMinutes: number
  navigateToTasks: () => void
  overdueTasks: number
  plannedMinutes: number
  totalTasks: number
  trackedHoursInfo: string
}

const ProjectStatusSection = ({
  completedTasks,
  imputedMinutes,
  navigateToTasks,
  overdueTasks,
  plannedMinutes,
  totalTasks,
  trackedHoursInfo,
}: ProjectStatusSectionProps) => {
  const trackedHoursTitle =
    plannedMinutes > 0
      ? i18n.t(
          'project_management.overview.sections.project_status.insights.tracked_estimated_hours'
        )
      : i18n.t('project_management.overview.sections.project_status.insights.tracked_hours')

  return (
    <Box gap="s20" paddingBottom="s8">
      <Text size="300" weight="semibold" color="grey1000">
        {i18n.t('project_management.overview.sections.project_status.title')}
      </Text>
      <Grid variant="fixed">
        <Box gridColSpan={{ xxs: 12, s: 6 }}>
          <InsightCard.Hours
            imputedMinutes={imputedMinutes}
            info={trackedHoursInfo}
            plannedMinutes={plannedMinutes}
            title={trackedHoursTitle}
          />
        </Box>
        <Box gridColSpan={{ xxs: 12, s: 6 }}>
          <InsightCard.Tasks
            completedTasks={completedTasks}
            onClickAction={navigateToTasks}
            overdueTasks={overdueTasks}
            title={i18n.t(
              'project_management.overview.sections.project_status.insights.task_progress.title'
            )}
            totalTasks={totalTasks}
          />
        </Box>
      </Grid>
    </Box>
  )
}

export default ProjectStatusSection
